import debbieBenningPhoto from '@/assets/quotes/debbie-benning.jpeg'
import type { MatchedBroker } from '@/routes/Public/marketing/components/MatchedBrokerNavCluster'
import type { NavLink } from '@/routes/Public/marketing/components/NavBar'

export const MATCHED_BROKER: MatchedBroker = {
  name: 'Debbie Benning',
  phone: '(404) 555-0182',
  email: 'debbie@cai.ai',
  avatarUrl: debbieBenningPhoto,
}

export const NAV_LINKS: NavLink[] = [
  { label: 'About', href: '#navigation' },
  {
    label: 'Products',
    items: [
      {
        label: 'Commercial Insurance',
        href: '#navigation',
        description: 'Auto liability, cargo, physical damages, and more',
      },
      { label: 'Compliance', description: 'Proactive, automated compliance.', tag: 'Coming soon' },
    ],
  },
  { label: 'Blog', href: '#navigation' },
]

// Stands in for a real application id in the nav's Copy link button.
export const DEMO_APPLICATION_ID = 'demo-application'
